import { useState } from 'react';
import { ScrollingColumn } from 'foundations-components/transitional/components/ScrollingColumn';
import Breadcrumbs from './general/Breadcrumbs';
import FilterFamilySubGroupSelectOptions from './FilterFamilySubGroupSelectOptions';
import Search from './general/Search';
import styled from 'foundations-theming/utils';
import PropertyTypeFilter from './general/PropertyTypeFilter';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SearchGrowContainer = styled.div.withConfig({
  displayName: "FilterFamilySubGroupSelect__SearchGrowContainer",
  componentId: "sc-1ixmz9u-0"
})(["flex-grow:1;"]);
const FilterFamilySubGroupSelect = ({
  groupLabel
}) => {
  const [searchString, setSearchString] = useState('');
  return /*#__PURE__*/_jsx(ScrollingColumn, {
    headerContent: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Breadcrumbs, {
        locationLabel: groupLabel
      }), /*#__PURE__*/_jsxs(Flex, {
        padding: "400",
        gap: "300",
        children: [/*#__PURE__*/_jsx(SearchGrowContainer, {
          children: /*#__PURE__*/_jsx(Search, {
            onSearchChange: evt => {
              setSearchString(evt.target.value);
            },
            searchPlaceholderAssetLabel: groupLabel,
            value: searchString
          })
        }), /*#__PURE__*/_jsx(PropertyTypeFilter, {
          onChange: () => {},
          values: [],
          disabled: true,
          tooltipContent: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFiltersUI.dataExplorer.typeFilter.disabledReason",
            options: {
              assetLabel: groupLabel
            }
          })
        })]
      })]
    }),
    children: /*#__PURE__*/_jsx(FilterFamilySubGroupSelectOptions, {
      searchString: searchString
    })
  });
};
export default FilterFamilySubGroupSelect;